export const inactiveColor = 'rgb(185, 193, 200)'
export const activeColor = '#B1CC43'
export const activeAccentColor = 'var(--dui-primary)'
